module.exports = __webpack_public_path__ + "media/images/flags/pf-825474cbc090f94cad4d79bab3db99a9.svg";